export enum TipoNumeracaoDocumentoEnum {
  Sequencial = 1,
  Manual = 2,
}
